import React from 'react';
import clsx from 'clsx';

import { parseSum } from 'utils/helpers';

import { Paper, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    paper: {
        minWidth: 260,
        textAlign: 'center',
        padding: theme.spacing(1, 2),
    },
    clickable: {
        cursor: 'pointer',
        '&:hover': { background: theme.palette.grey[300], color: theme.palette.primary.main },
    },
    badgeText: {
        lineHeight: 1,
        fontSize: 28,
    },
}));

const ChartHeader = props => {
    const { number, title, useSymbol, handleClick } = props;
    const classes = useStyles();

    return (
        <Paper
            elevation={0}
            className={clsx({ [classes.paper]: true, [classes.clickable]: !!handleClick })}
            onClick={handleClick}
        >
            <Typography className={classes.badgeText}>{title}</Typography>
            <Typography className={classes.badgeText}>
                {useSymbol ? parseSum(number) : number}
            </Typography>
        </Paper>
    );
};

export default ChartHeader;
